<template>
  <div class="overflow-hidden min-h-[165px] font-bold">
    <AppDataProperty
      contentId="liveFilteredMatches"
      eventToListen="matches_filtered"
      @dataAvailable="
        data => {
          setMatches(data?.metaData?.topMatches)
        }
      "
    />
    <!-- {{ liveMatches }} -->
    <div class="flex gap-5 px-6 items-center title-color justify-between">
      <div class="textComponent text-xl font-semibold">
        {{ $t('matches.liveMatchesTitle') }}
      </div>
      <div>
        <button class="w-8 min-w-8 h-8" @click="showFilters" id="match-filter">
          <img
            v-if="$ColorTheme.isLight()"
            src="@/assets/images/all/setting.svg"
            alt=""
          />
          <img v-else src="@/assets/images/all/setting-white.svg" alt="" />
        </button>
      </div>
    </div>
    <div class="py-2"></div>
    <div class="px-4 group relative matchesScrollContainer">
      <ListComponent
        v-if="liveMatches.length"
        v-slot="slotData"
        class="relative h-full overflow-auto"
        itemContainerHeight="100%"
        :itemContainerWidth="165"
        :itemsClasses="[]"
        directUseItems
        :allItems="liveMatches"
        scrollContainerSelector="#livematchescontainer"
        id="livematchescontainer"
        :loadingMoreEnd="false"
        ref="list"
      >
        <div class="px-2">
          <div
            class="rounded-[20px] ripple text-white overflow-hidden"
            @click="showMatch(slotData.data?.item)"
            :class="{
              match0: (slotData.data?.item?.id || 0) % 3 == 0,
              match1: (slotData.data?.item?.id || 0) % 3 == 1,
              match2: (slotData.data?.item?.id || 0) % 3 == 2,
            }"
          >
            <div
              class="h-[140px]"
              v-if="
                !slotData.data?.item?.matchStatus ||
                slotData.data?.item?.shimmer
              "
            ></div>
            <div class="" v-else>
              <div class="p-4">
                <div class="flex justify-between">
                  <div
                    class="px-2 py-1 shadow-sm bg-white bg-opacity-30 rounded-lg"
                  >
                    LIVE
                  </div>
                  <div class="flex text-xs gap-1 items-center">
                    <div>{{ slotData.data.item.liveDurationMin }} min</div>
                    <div
                      class="bg-red-500 border-white border-[3px] w-5 h-5 rounded-full"
                    ></div>
                  </div>
                </div>
                <div class="py-2"></div>
                <div class="flex items-center justify-between h-[30px]">
                  <div
                    class="w-[23%] flex flex-col items-center title-description-color"
                  >
                    <div class="w-full">
                      <img
                        class="w-full object-contain object-center"
                        :src="slotData.data.item.team1Picture"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>vs</div>
                  <div
                    class="w-[23%] flex flex-col items-center title-description-color"
                  >
                    <div class="w-full">
                      <img
                        class="w-full object-contain object-center"
                        :src="slotData.data.item.team2Picture"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-4 pt-2 bg-white bg-opacity-20">
                <div class="flex items-center">
                  <div class="flex gap-2">
                    <marquee scrollamount="2">
                      {{ slotData.data.item.team1Name }}
                    </marquee>
                    <div>Vs</div>
                    <marquee scrollamount="2">
                      {{ slotData.data.item.team2Name }}
                    </marquee>
                  </div>
                </div>
                <div class="pt-1"></div>
                <div class="flex gap-1 items-center text-sm">
                  <div class="w-6 h-6 p-1 bg-[#002E5E] bg-opacity-50 rounded">
                    <img
                      src="@/assets/images/all/1xBetFull-white.svg"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                  <div>Sur 1xBet</div>
                </div>
                <div class="py-1"></div>
                <div class="flex justify-between items-center">
                  <div class="flex gap-1 items-center">
                    <div class="w-8 h-8">
                      <img
                        src="@/assets/images/all/trophee.svg"
                        alt=""
                        class="w-full h-full"
                      />
                    </div>
                    <div class="w-8 h-8 -ml-6 opacity-40">
                      <img
                        src="@/assets/images/all/trophee.svg"
                        alt=""
                        class="w-full h-full"
                      />
                    </div>
                    <div>
                      <div>
                        {{ slotData.data.item.team1Score }} :
                        {{ slotData.data.item.team2Score }}
                      </div>
                      <div class="opacity-50 text-sm">Score</div>
                    </div>
                  </div>
                  <div>
                    <div class="rounded-xl glassBg px-3 py-1">Cotes</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ListComponent>
      <div
        class="h-full w-full flex-col flex items-center justify-center"
        v-else
      >
        <div class="w-24 h-24">
          <img
            v-if="$ColorTheme.isLight()"
            src="@/assets/images/all/football.svg"
            alt=""
          />
          <img v-else src="@/assets/images/all/football-white.svg" alt="" />
        </div>
        <div class="py-4"></div>
        <div class="text-center text-2xl">
          {{ $t('matches.noLiveMatch') }}
        </div>
        <div class="text-center w-2/3">
          {{ $t('matches.noLiveMatchDescription') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListComponent from '../utils/ListComponentVirtualScrollHz.vue'
import AppDataProperty from './AppDataProperty.vue'
import MatchFiltersComponent from './MatchFiltersComponent.vue'
// import filterIcon from '@/assets/images/all/filter.svg'
// import filterIconWhite from '@/assets/images/all/filter-white.svg'

export default defineComponent({
  name: 'LiveMatches',
  components: { AppDataProperty, ListComponent, MatchFiltersComponent },
  props: {},
  data() {
    return {
      shimmerMatches: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      liveMatches: [{ shimmer: true }],
      eventsIds: [],
    }
  },
  mounted() {
    this.liveMatches = JSON.parse(JSON.stringify(this.shimmerMatches))
    this.$Events.dispatchEvent(
      'required_tour_guide',
      {
        el: '#match-filter',
        title: this.$t('matches.filterGuideText'),
        id: 'match-filter',
        position: 'bottom-left',
      },
      2000,
    )
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    setMatches(matches) {
      if (!Array.isArray(matches)) return
      if (
        this.liveMatches[0] &&
        !this.liveMatches[0].shimmer &&
        this.liveMatches.length == matches.length
      )
        return
      this.liveMatches = matches.slice(0, 10)
      this.liveMatches.push(...new Array(3).fill({ shimmer: true }))
      setTimeout(() => {
        this.liveMatches = matches
      }, 4000)
    },
    showMatch(match) {
      this.$Events.dispatchEvent('match_detail_required', match)
    },
    showFilters() {
      this.$Events.dispatchEvent('show_filters_required')
    },
  },
  computed: {
    // filteredMatches() {
    //   if (this.liveMatches[0].shimmer) return this.liveMatches
    //   if (!this.matchFilters[0]) return this.liveMatches
    //   const filtersIds = this.matchFilters.map(filter => filter?.id)
    //   return this.liveMatches.filter(match =>
    //     filtersIds.includes(match.league?.league_id),
    //   )
    // },
  },
})
</script>

<style scoped>
.match0 {
  background: linear-gradient(169.09deg, #af8ffe 30.12%, #e294fe 87.39%);
}
.match1 {
  background: linear-gradient(169.09deg, #00aa8e 30.12%, #95d279 87.39%);
}
.match2 {
  background: linear-gradient(169.09deg, #e77672 30.12%, #ff8a86 87.39%);
}
</style>
